module.exports = __webpack_public_path__ + "static/식용유밀가루-ef23ccd6e3ed8b0d6495e2a975ab812a.jpg";